import _ from 'lodash'
import router from '@/router'

export default {

  // fn: takes a route name and returns its path
  getPath (name) {
    // get route
    let route = _.find(router.options.routes, { name })

    // return its path
    return _.isObject(route) ? '/#' + route.path : ''
  },

  // fn: return the current route
  getCurrentRoute () {
    return router.history.current
  }
}



// WEBPACK FOOTER //
// ./src/services/$glRouter.js